import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

const AddonsList = lazy(() => import('../../container/pages/AddonsList'));
const AddonsAdd = lazy(() => import('../../container/pages/AddonsAdd'));
const AddonsEdit = lazy(() => import('../../container/pages/AddonsEdit'));
const AddonChoiceAdd = lazy(() => import('../../container/pages/AddonChoiceAdd'));
const AddonChoiceEdit = lazy(() => import('../../container/pages/AddonChoiceEdit'));

const AddonRoute = () => {
  return (
    <Routes>
      <Route path="list" element={<AddonsList />} />
      <Route path="add" element={<AddonsAdd />} />
      <Route path="edit/:addonId" element={<AddonsEdit />} />
      <Route path=":addonId/choice/add" element={<AddonChoiceAdd />} />
      <Route path=":addonId/choice/edit/:choiceId" element={<AddonChoiceEdit />} />
    </Routes>
  );
};

export default AddonRoute;
